module.exports = __webpack_public_path__ + "static/media/bttn_tile.fd697fa1.svg";